import {actionChannel, delay, put, take} from 'redux-saga/effects';
import {buffers} from 'redux-saga';

export function* throttledActionGenerator(throttleAction, action, waitingTime) {
	try {
		const buffer = buffers.sliding(1);
		const requestChan = yield actionChannel(throttleAction.toString(), buffer);
		while (true) {
			const { payload } = yield take(requestChan);
			yield put(action(payload));
			yield delay(waitingTime);
			if (!buffer.isEmpty()) {
				const { payload: nextPayload } = yield take(requestChan);
				yield put(action(nextPayload));
			}
		}
	} catch (e) {
		console.log('throttledActionGenerator: Error', e);
	}
}

